import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IPaperKeywordsData } from 'editing-tool/src/app/shared/components/paper/steps/keywords/paper-keywords-data';

@Component({
    selector: 'et-paper-keywords',
    templateUrl: './paper-keywords.component.html',
    standalone: false
})
export class PaperKeywordsComponent {

    @Input()
    public data: IPaperKeywordsData;

    @Input()
    public isReadonly: boolean;

    @Output()
    public readonly keywordsCountChanged = new EventEmitter<void>();

    public onKeywordCountChanged(): void {
        this.keywordsCountChanged.emit();
    }
}
